import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";

import {MAIN_APP, PROCESSOR_COUNT} from '../MidiPlay.jsx';

import Colors from '../resource/ResourceColors.jsx';

const ProcessorWrapper = styled.div`
    display: inline-block;
    width: 12rem;
`;

const LightBorder = styled.div`
    float: right;
    width: 1rem;
    height: 1rem;
    border-radius: 0.6rem;
    margin: 0.15rem;    
    border: 0.1rem solid ${Colors.grey(60)};
    filter: ${Colors.medium_shadow(50)};
`;

const ColoredLight = styled.div`
    width: 0.8rem;
    height: 0.8rem;
    border-radius: 0.5rem;
    background-color: white;
    border: 0.1rem solid ${Colors.grey(20)};    
    box-shadow: inset ${Colors.medium_raw_shadow(40, true)}}
`;

export class ModuleProcessors extends Component {

    static propTypes = {
        expanded: PropTypes.bool
    }

    colored_light(p, key) {
        let bg_color = p.active ? p.action.hsl_str : Colors.grey(50);
        const style = {backgroundColor: bg_color}
        return <LightBorder key={'lamp-border-' + key} >
            <ColoredLight style={style}/>
        </LightBorder>
    }

    get_empty_profiles() {
        let profile_data = []
        for (let i = 0; i < PROCESSOR_COUNT; i++) {
            profile_data.push({active: false});
        }
        return profile_data;
    }

    render() {
        const profile_data = MAIN_APP.state.playing ? MAIN_APP.state.profile_data : this.get_empty_profiles();
        const processors = profile_data.map((p, key) => {
            return this.colored_light(p, key);
        });
        return <ProcessorWrapper>
            {processors}
        </ProcessorWrapper>;
    }
}

export default ModuleProcessors;
